<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemKey: {
      type: String,
      default: 'id',
    },
    color: {
      type: String,
      default: 'primary',
    },
    addButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      deleteDialog: false,
      deleteItem: {},
    }
  },

  computed: {
    tableHeaders() {
      const actionHeader = [{ text: 'Actions', sortable: false }]
      return this.headers.concat(actionHeader)
    },
  },

  methods: {
    onExpand(props) {
      props.expanded = !props.expanded
      this.$emit('edit', props.item)
    },
    onDelete(props) {
      this.deleteDialog = true
      this.deleteItem = props.item
    },
    closeDialog() {
      this.deleteDialog = false
      this.deleteItem = {}
    },
    confirmDelete() {
      this.$emit('delete', this.deleteItem)
      this.closeDialog()
    },
  },
}
</script>

<template>
  <div>
    <VCard>
      <!-- VToolbar -->
      <VToolbar color="white" card>
        <VToolbarTitle :class="`${color}--text`">
          {{ title }}
        </VToolbarTitle>

        <slot slot="extension" name="extension" />

        <VSpacer />

        <slot name="actions" />
        <VBtn
          v-if="addButton"
          :color="color"
          depressed
          dark
          @click="$emit('add')"
        >
          Add
        </VBtn>
      </VToolbar>
      <!-- End of VToolbar -->

      <!-- VCardText -->
      <VCardText>
        <VDataTable
          :headers="tableHeaders"
          :items="items"
          :loading="loading"
          :item-key="itemKey"
          hide-actions
        >
          <!-- Item Slot -->
          <template slot="items" slot-scope="props">
            <td
              v-for="(header, index) in headers"
              :key="`${header.text}-${index}`"
            >
              {{ props.item[header.value] }}
            </td>
            <td>
              <!-- Edit Icon -->
              <VIcon small class="mr-2" @click="onExpand(props)">
                edit
              </VIcon>
              <!-- End of Edit Icon -->

              <!-- Delete Icon -->
              <VIcon small @click="onDelete(props)">
                delete
              </VIcon>
              <!-- End of Delete Icon -->
            </td>
          </template>
          <!-- End of Item Slot -->

          <!-- Expand Slot -->
          <template slot="expand" slot-scope="props">
            <slot :expand="props" />
          </template>
          <!-- End of Expand Slot -->
        </VDataTable>
      </VCardText>
      <!-- End of VCardText -->
    </VCard>

    <VDialog v-model="deleteDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Delete entry</VCardTitle>
        <VCardText>Are you sure want to delete this entry?</VCardText>
        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="closeDialog">Cancel</VBtn>
          <VBtn :color="color" flat @click="confirmDelete">Delete</VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </div>
</template>
